import { Stack, Typography } from '@mui/material'
import React from 'react'

import { ReliabilityManagement101Tutorial } from './ReliabilityManagement101Tutorial'

export const ReliabilityManagement101: React.FC = () => {
  return (
    <div data-test-reliability-management-101>
      <Typography variant="h5">Reliability Management 101</Typography>
      <Stack mt={3} spacing={2}>
        <video
          controls
          playsInline
          css={{
            maxWidth: '100%'
          }}
          poster="https://res.cloudinary.com/gremlin/image/upload/v1669669302/Videos/Demos/default-cover.png"
        >
          <source src="https://res.cloudinary.com/gremlin/video/upload/v1668721899/Videos/Demos/Getting_started_with_Gremlin_RM.mp4" />
        </video>
        <ReliabilityManagement101Tutorial />
      </Stack>
    </div>
  )
}
